var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("第一层")]),_c('p',[_vm._v("获取父组件数据："+_vm._s(_vm.msg))]),_c('button',{on:{"click":_vm.send}},[_vm._v("发送数据")]),_c('button',{on:{"click":_vm.getParent}},[_vm._v("获取父组件实例")]),_c('hr'),_c('Ceng2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }